import { render, staticRenderFns } from "./ProductNotifications.vue?vue&type=template&id=8e2fb52c&scoped=true&"
import script from "./ProductNotifications.vue?vue&type=script&lang=js&"
export * from "./ProductNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ProductNotifications.vue?vue&type=style&index=0&id=8e2fb52c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2fb52c",
  null
  
)

export default component.exports